import { ApiAppInstances, IQueuedRequest, OneAPIOptions } from '../common'
import uuid from 'uuid-random'
import { Queue } from '../queue'
import { AccountApp } from './account'
import { AnalyticsApp } from './analytics'
import { OrderpathApp } from './orderpath'
import { OrdersApp } from './orders'
import { StocksApp } from './stocks'
import { CatalogApp } from './catalog'
import { AuthApp } from './auth'
import { PricingApp } from './pricing'
import { CmsApp } from './cms'
import { InvoicesApp } from './invoices'
import { GoodsIssuedNotesApp } from './goodsIssuedNotes'
import { RmaApp } from './rma'
import { ProductsApp } from './products'
import { PluginsApp } from './plugins'
import { PaymentsApp } from './payments'
import { WebhooksApp } from './webhooks'
import { AxiosPromise } from 'axios'
import { CMS } from '@one/types'
import { RelationsApp } from './relations'

export interface ApisApp {
  account: AccountApp
  analytics: AnalyticsApp
  orderpath: OrderpathApp
  orders: OrdersApp
  stock: StocksApp
  catalog: CatalogApp
  authserver: AuthApp
  pricing: PricingApp
  cms: CmsApp
  invoices: InvoicesApp
  goodsIssuedNotes: GoodsIssuedNotesApp
  rma: RmaApp
  product: ProductsApp
  payments: PaymentsApp
  plugins: PluginsApp
  relations: RelationsApp
  webhooks: WebhooksApp

  flushQueue(): void
  invalidateAllInstances(): void
  getListSettings(
    service: string
  ): AxiosPromise<Array<CMS.Responses.SettingDto>>
  getSettings(
    service: string,
    key: string
  ): AxiosPromise<CMS.Responses.SettingDto>
  setSettings(service: string, key: string, body: any): AxiosPromise<void>
}

export const initApp = (options: OneAPIOptions): ApisApp => {
  const sessionId: string = uuid()
  const requestsQueue: Queue<IQueuedRequest> = new Queue()
  const instances: ApiAppInstances = {
    account: new AccountApp('account', sessionId, requestsQueue, options),
    analytics: new AnalyticsApp('analytics', sessionId, requestsQueue, options),
    orderpath: new OrderpathApp('orderpath', sessionId, requestsQueue, options),
    orders: new OrdersApp('orders', sessionId, requestsQueue, options),
    stock: new StocksApp('stock', sessionId, requestsQueue, options),
    catalog: new CatalogApp('catalog', sessionId, requestsQueue, options),
    authserver: new AuthApp('authserver', sessionId, requestsQueue, options),
    pricing: new PricingApp('pricing', sessionId, requestsQueue, options),
    cms: new CmsApp('cms', sessionId, requestsQueue, options),
    invoices: new InvoicesApp('invoices', sessionId, requestsQueue, options),
    goodsIssuedNotes: new GoodsIssuedNotesApp(
      'goods-issued-notes',
      sessionId,
      requestsQueue,
      options
    ),
    rma: new RmaApp('rma', sessionId, requestsQueue, options),
    product: new ProductsApp('product', sessionId, requestsQueue, options),
    plugins: new PluginsApp('plugins', sessionId, requestsQueue, options),
    payments: new PaymentsApp('payments', sessionId, requestsQueue, options),
    relations: new RelationsApp('relations', sessionId, requestsQueue, options),
    webhooks: new WebhooksApp('webhooks', sessionId, requestsQueue, options)
  }
  return {
    ...instances,
    flushQueue() {
      while (requestsQueue.size()) {
        const request: IQueuedRequest | undefined = requestsQueue.pop()
        if (request) {
          request.resolve()
        }
      }
    },
    invalidateAllInstances: () => {
      Object.keys(instances).map(instance =>
        // @ts-ignore
        instances[instance].invalidateAll()
      )
    }
  } as ApisApp
}
